import {PipelineGraphQL} from 'pipelines/PipelineTypes';

/**
 * Paste steps from the user's clipboard into the pipeline.
 *
 * @param pipeline - The pipeline to paste steps into.
 */
export async function pasteStepsFromClipboard(
  pipeline: Pick<PipelineGraphQL, 'steps' | 'id'>
): Promise<void> {
  // TODO(BNCH-155659): Paste step upserts from clipboard.
  await Promise.resolve();
}
